"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _react = require("@emotion/react");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const growShrinkAnimation = (0, _react.keyframes)`
0%, 100% {
  width: 22px;
  height: 22px;
  font-size: 1rem;
}
50% {
  width: 26px;
  height: 26px;
  font-size: 1.2rem;
}
`;
const Root = exports.Root = (0, _mui.styled)(_mui.Badge, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isAnimationActive'])
})(({
  isAnimationActive
}) => ({
  [`.${_mui.badgeClasses.badge}`]: {
    borderRadius: '50%',
    ...(isAnimationActive && {
      animationDuration: '1s',
      animationName: `${growShrinkAnimation}`
    })
  }
}));
